import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  BASE_FONT_FAMILY,
  LOGIN_HIGHLIGHT_COLOR,
  LOGIN_BUTTON_BG_COLOR,
  LOGIN_BUTTON_TEXT_COLOR
} = constants;

let styles = {
  base: {
    minWidth: 75,
    fontFamily: BASE_FONT_FAMILY,
    fontSize: '1.1em',
    fontWeight: 600,
    textAlign: 'center',
    cursor: 'pointer',
    padding: '12px 27px',
    border: `1px solid ${LOGIN_HIGHLIGHT_COLOR}`,
    borderRadius: 7,
    backgroundColor: LOGIN_BUTTON_BG_COLOR,
    color: LOGIN_BUTTON_TEXT_COLOR
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/inputs/loginbutton/LoginButton.styles.js